export default {
    back: 'Back',
    COI: 'Current Outage Information',
    static: 'The Estimated Restoration time above is the most conservative for the outages that are located in this Municipality.',
    CPR: 'Customers Projected to be Restored',
    noCOI: 'No outage information to display at this time.',
    noCPR: 'No current outages at this time.',
    EI: 'Electric Infrastructure',
    noEI: 'Electric infrastructure information is currently unavailable.',
    URP: 'Understanding the Restoration Process',
    fallbackURL: '/fallbackReport'
};
